import { openAtcNotice } from '../sections/atc'

// quickview atc functionality
function addToCart() {
  var variant_id = jQuery('[data-quickview-variant-id]').attr('data-quickview-variant-id')
  var qty = jQuery('[data-product-quantity] option:selected').val()
  var giftWrap = jQuery('[data-gift-wrapping]').prop('checked')
  var data = {
  }
  if(giftWrap) {
    data.giftWrap = true
  }
  console.log(variant_id, qty)
  CartJS.addItem(variant_id, qty, data, {
    "success": function(data, textStatus, jqXHR) {
      closeModal();
      openAtcNotice(data, qty)
    }
  })
}

// Modal JS

function closeModal() {
  const body = document.body;
  const modal = document.querySelector(".modal");
  const modalOverlay = document.querySelector(".modal-overlay");
  const modalContainer = document.querySelector(".modal-container");
  modal.classList.add("opacity-0");
  modal.classList.add("pointer-events-none");
  modalOverlay.classList.toggle("opacity-0");
  modalOverlay.classList.toggle("opacity-50");
  body.classList.remove("modal-active");
}

function openModal(url) {
  jQuery(".modal-overlay").toggleClass("opacity-0 opacity-50");
  const body = document.body;
  const modal = document.querySelector(".modal");
  body.classList.toggle("modal-active");
  jQuery.getJSON(url + ".js", function(product) {
    var sel = {
      $testObj: "[testobj]"
    };
    console.log(product);
    buildSwatches(product)
    jQuery("[data-quickview-product-title]").text(product.title);
    var desc = product.description.substr(0,100) + '...';
    var price = (product.price / 100).toFixed(2)
    jQuery("[data-quickview-product-description]").html(desc);
    jQuery("[data-quickview-product-url]").attr("href", product.url);
    jQuery("[data-quickview-product-price]").text(
      `$${price}`
    );
    jQuery("[data-quickview-product-img]").attr(
      "src",
      product.featured_image
    );
    jQuery('[data-quickview-variant-id]').attr('data-quickview-variant-id', product.variants[0].id)
    var qty = jQuery("[data-quickview-product-qty");
    if (!product.available) {
      jQuery("button[data-quickview-atc]").attr("disabled", true)
      jQuery("button[data-quickview-atc]").html("Sold out")
    } else {
      jQuery("button[data-quickview-atc]").attr("disabled", false)
      jQuery("button[data-quickview-atc]").html("Add to cart")
    }
    // modal.classList.toggle("opacity-0");
    modal.classList.toggle("pointer-events-none");
    jQuery(".fa-sync-alt").toggleClass("hidden");
    jQuery(".modal").toggleClass("opacity-0");
  });
}

function buildSwatches(product) {
  let labelContainer = document.createElement('div'),
      quickviewVariants = document.querySelector('.quickview-product-variants'),
      swatchContainer = document.createElement('div');

  quickviewVariants.innerHTML = ''

  if (product.options[0].name === 'Gemstone') {

    labelContainer.innerHTML = `<span data-current-variant-indicator class="text-enewton-gray-400">gemstone: <span data-current-variant class="text-enewton-gray-800"></span></span>`
    swatchContainer.classList.add('flex-row', 'flex', 'mt-3', 'flex-wrap')

    quickviewVariants.appendChild(labelContainer)
    product.variants.forEach((variant, index) => {
      let variantContainer = document.createElement('span')
      variantContainer.classList.add('swatch', 'rounded-full', 'h-8', 'w-8', 'bg-cyan-light-700', 'flex', 'items-center', 'justify-center', 'mr-2', 'cursor-pointer', 'mb-2')
      if (index ===  0) {
        variantContainer.classList.add("selected")
        labelContainer.querySelector('span[data-current-variant]').innerText = variant.title.toLowerCase()
      }
      variantContainer.setAttribute("index", index)
      variantContainer.dataset.variantId = variant.id
      variantContainer.dataset.variantSku = variant.sku
      variantContainer.dataset.variantTitle = variant.title.toLowerCase()
      variantContainer.dataset.variantImgSrc = variant.featured_image !== null ? variant.featured_image.src : ""
      swatchContainer.appendChild(variantContainer)
      variantContainer.addEventListener('click', (e) => variantSelector(e, variantContainer))
    });

    quickviewVariants.appendChild(swatchContainer)

  } else if (product.variants.length > 1 && product.options[0].name !== 'Gemstone') {
    let labelContainer = document.createElement('label'),
        swatchContainer = document.createElement('select');

    labelContainer.setAttribute("for", product.options[0].name)
    swatchContainer.id = "variant-selector"

    product.variants.forEach((variant, index) => {
      console.log(variant);
      let variantContainer = document.createElement('option'),
          price = variant.price / 100;
      variantContainer.dataset.variantPrice = price.toFixed(2)
      variantContainer.setAttribute("index", index + 1)
      variantContainer.setAttribute("value", variant.id)
      variantContainer.dataset.variantId = variant.id
      variantContainer.dataset.variantSku = variant.sku
      variantContainer.dataset.variantTitle = variant.title.toLowerCase()
      variantContainer.dataset.variantImgSrc = variant.featured_image !== null ? variant.featured_image.src : ""
      variantContainer.innerText = variant.title
      swatchContainer.appendChild(variantContainer)
    });

    swatchContainer.addEventListener('change', (e) => variantSelector(e, swatchContainer))

    quickviewVariants.appendChild(swatchContainer)
    quickviewVariants.appendChild(labelContainer)
  }
}

function variantSelector (e, $this){
  if (e.type === 'click') {
    if ($this.parentElement.querySelector('.selected') !== $this) {
      $this.parentElement.querySelector('.selected').classList.remove('selected')
    }
    $this.classList.add('selected')
    let selector = document.querySelector('.modal-body span[data-quickview-variant-id]'),
    productId = $this.dataset.variantId;
    selector.setAttribute('data-quickview-variant-id', productId)
    document.querySelector('.modal-body span[data-current-variant]').innerText = $this.dataset.variantTitle
    if ($this.dataset.variantImgSrc) {
      document.querySelector('.modal-body img').setAttribute('src', $this.dataset.variantImgSrc)
    }
  } else {
    let productId = $this.value,
        selected = $this.querySelector(`option[value='${productId}']`),
        selector = document.querySelector('.modal-body span[data-quickview-variant-id]');

    selector.setAttribute('data-quickview-variant-id', productId);
    if (selected.dataset.variantImgSrc) {
      document.querySelector('.modal-body img').setAttribute('src', selected.dataset.variantImgSrc)
    }
  }
}


  const init = () => {
    jQuery(document).ready(function() {

    // Sort JS
    Shopify.queryParams = {};
    if (location.search.length) {
      for (
        var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
        i < aCouples.length;
        i++
      ) {
        aKeyValue = aCouples[i].split("=");
        if (aKeyValue.length > 1) {
          Shopify.queryParams[
            decodeURIComponent(aKeyValue[0])
          ] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    jQuery("#sort-by")
    .val(
      "{{ collection.sort_by | default: collection.default_sort_by | escape }}"
    )
    .bind("change", function() {
      Shopify.queryParams.sort_by = jQuery(this).val();
      location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, "%20");
    });

    var openmodal = document.querySelectorAll(".quick-view");
    for (var i = 0; i < openmodal.length; i++) {
      openmodal[i].addEventListener("click", function(event) {
        event.preventDefault();
        var prodUrl = jQuery(this).attr("data-product-url");
        openModal(prodUrl);
      });
    }

    const overlay = document.querySelector(".modal-overlay");
    var closemodal = document.querySelectorAll(".modal-close");
    for (var i = 0; i < closemodal.length; i++) {
      closemodal[i].addEventListener("click", function() {
        closeModal();
      });
    }
    overlay.addEventListener("click", function() {
      closeModal();
    });

    document.onkeydown = function(evt) {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }

      if (isEscape && document.body.classList.contains("modal-active")) {
        closeModal();
      }
    };
    // quickview atc functionality
    jQuery('[data-quickview-atc]').on('click', addToCart);

      // product card hover functionality
      jQuery("div[data-collection-single-product]").hover(
        function() {
          // hover on
          var par = jQuery(this);
          var url2 = par.find('img[data-product-img].inactive').attr('src')
          if(url2.includes('no-image')) {
            par.find(".atc-btn").removeClass("hidden");
            par.find(".quick-view").removeClass("md:hidden");
            par.find("[data-wishlist-toggle]").removeClass("hidden");
            par.find("[data-variants]").removeClass("hidden");
          } else {
            par.find(".atc-btn").removeClass("hidden");
            par.find(".quick-view").removeClass("md:hidden");
            par.find("[data-wishlist-toggle]").removeClass("hidden");
            par.find("[data-variants]").removeClass("hidden");
            jQuery(this)
              .find("img[data-product-img].active")
              .fadeOut(230, function() {
                jQuery(this).attr("src2", jQuery(this).attr("src"));
                jQuery(this).attr(
                  "src",
                  par.find("img[data-product-img].inactive").attr("src")
                );
                jQuery(this).fadeIn(230, function() {});
              });
          }
        },
        function() {
          // hover off
          var par = jQuery(this);
          var url2 = par.find('img[data-product-img].inactive').attr('src')
          par.find(".atc-btn").toggleClass("hidden");
          par.find(".quick-view").toggleClass("md:hidden");
          par.find("[data-wishlist-toggle]").toggleClass("hidden");
          par.find("[data-variants]").toggleClass("hidden");
          if(!url2.includes('no-image')) {
          jQuery(this)
            .find("img[data-product-img].active")
            .fadeOut(230, function() {
              jQuery(this).attr(
                "src",
                par.find("img[data-product-img].active").attr("src2")
              );
              jQuery(this).fadeIn(230, function() {});
            });
          }
        }
      );
    });
  }

  export default init
